
import { apiRequest } from "./ApiUtility";

export async function forgotPassword(email) {
  const url = "/api/account/forgotpassword";
  const data = {
    email: email,
    baseUrl: window.location.origin
  };
  
  // Since these functions don't use authContext, we pass null
  return await apiRequest("post", url, null, data);
}

export async function resetPassword(token, email, password) {
  const url = "/api/account/resetpassword";
  const data = {
    token: token,
    email: email,
    password: password
  };
  
  // Since these functions don't use authContext, we pass null
  return await apiRequest("post", url, null, data);
}